import { debounce } from 'lodash';

const targetHeightContainerId = 'profile-height-benchmark';
const scrollContainerId = 'profile-scroll-container';
const debounceTimeoutMills = 150;

const setScrollContainerHeight = () => {
  const targetHeightContainer = document.querySelector<HTMLDivElement>(`#${targetHeightContainerId}`);
  const scrollContainer = document.querySelector<HTMLDivElement>(`#${scrollContainerId}`);

  if (targetHeightContainer && scrollContainer) {
    scrollContainer.style.maxHeight = `${targetHeightContainer.clientHeight}px`;
  }
};

const fixateScrollContainerHeight = () => {
  setScrollContainerHeight();

  const debouncedListener = debounce(setScrollContainerHeight, debounceTimeoutMills) as () => void;

  window.addEventListener('resize', debouncedListener);

  window.addEventListener('unload', () => {
    window.removeEventListener('resize', debouncedListener);
  });
};

export const srollProfileToTop = () => {
  const profileContainer = document.querySelector(`#${scrollContainerId}`);

  const cursedIosScrollTimeout = 50;

  if (profileContainer) {
    // iOS ignore may ignore scroll w/o timeout -- https://stackoverflow.com/a/71181885/5562460
    setTimeout(() => {
      profileContainer.scrollTo({
        top: 0,
        behavior: 'smooth',
      });

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, cursedIosScrollTimeout);
  }
};

export default fixateScrollContainerHeight;
